import React, { useEffect, useState } from "react";
import '../../../CSS/TablaHerramientas.css'
import { FaUserCheck, FaEdit} from "react-icons/fa";
import { FcCheckmark } from "react-icons/fc";
import { IoClose } from "react-icons/io5";
import { MdTimerOff } from "react-icons/md";
import {getPermission} from '../../../Conexiones/Conexion'
import { useNavigate } from "react-router";
import moment from "moment/moment";
import {  CloseButton, Modal } from 'react-bootstrap';
import Select from 'react-select';
import { FaArrowLeftLong } from "react-icons/fa6";
import Loading from '../../../Utils/Loading';
import { getApi, postApi, putApi } from "../../../Conexiones/Models";
import { errorMessage, errorToast, successToast, warningToast } from "../../../Utils/AlertMessage";

function AsistenciaObra(){
    const navigate = useNavigate();
    const day = moment().isoWeekday();
    const [isLoading,setIsLoading]=useState(false);
    const [listaAsistencia, setListaAsistencia] = useState([]);
    const obraId = parseInt(sessionStorage.getItem("obra"));
    const [inicio, setInicio] = useState("");
    const [fin, setFin] = useState("");
    const [fechaSelect, setFechaSelect] = useState("");
    const [semana, setSemana] = useState("");
    const [idEmp, setIdEmp] = useState();
    const [fechas, setFechas] = useState([]);
    const [extra, setExtra] = useState(null);
    const [asisActual, setAsisActual] = useState(null);
    const [asistencia, setAsistencia] = useState(null);
    const [fecha,setFecha] = useState("");
    const [obs, setobs] = useState("");
    const [obra,setObra] = useState('');
    const [isSaving, setSaving] = useState(false);
    //AGREGAR ASISTENCIA ATRASADA
    const [showAddAsis, setShowAdAsis] = useState(false);
    const [nombre, setNombre] = useState(null);
    const [tipo,setTipo] = useState('');
    const [observacion, setObservacion] = useState('');
    const [fechaAtrasada, setFechaAtrasada] = useState(null);
    const [asisAtras, setAsisAtras] = useState(null);
    const [listAtrasada, setLisAtrasada] = useState([]);
    const usuario = JSON.parse(sessionStorage.getItem('user'));
    const idUsuario = usuario[0].idUsuario;

    //EDITAR ASISTENCIA
    const [showEdit, setShowEdit] = useState(false);
    const handleCloseEdit = () => {
      setShowEdit(false);
      setAsisActual(null);
      setAsistencia(null);
      setFecha("");
      setobs("");
      setExtra("");
    }
    const [editNombre,setEditNombre] = useState ();

    const handleShowEdit = async (id,nombre,tipo) =>{
        await asisSemana(id,tipo);
        setShowEdit(true);
        setEditNombre(nombre);
        setIdEmp(id);
        setTipo(tipo);
    }
    //AGREGAR ASISTENCIA
    const [fechaEdit,setFechaEdit] = useState('');
    const [listEmpAsis, setListEmpAsis] = useState([]);
    const [lista, setLista] = useState([]);
    const [showListAsis, setShowListAsis] = useState(false);

    const handleCloseAsis = () => {
        setShowListAsis(false);
        setLista([]);
    }

    const handleShowAsis = async () =>{
        await getPersonalObra();
        setShowListAsis(true);
    }

    const handleCloseAdd = () => {
        setNombre(null);
        setFechaAtrasada(null);
        setAsisAtras(null);
        setShowAdAsis(false);
    }
    const handleShowAdd = async () =>{
        await getListaAtrasada();
        setShowAdAsis(true);
    }
    ///////////////////////////////////////////////////////////////////////
    useEffect (()=>{
        const getLista_actual = async () =>{
            setIsLoading(true);
            const permiso = await getPermission(idUsuario,23);
            if(permiso){
                var date = moment( new Date());
                const fecha = date.tz('America/Mexico_City').format('YYYY-MM-DD');
                const endpoint = 'get-asis-ini/'+obraId+'/'+fecha;
                const res = await getApi(endpoint);
                if(res.status === 1){
                    if(res.data.length !== undefined){
                        setListaAsistencia(res.data[0].asistencia);
                        setInicio(res.data[0].inicio);
                        setFin(res.data[0].fin);
                        setSemana(res.data[0].semana);
                        setObra(res.data[0].obra);
                    }else{
                        errorMessage(res.data.message);
                    }
                }else if(res.status === 210){
                    navigate('/');
                }else{
                    errorMessage(res.message);
                }
            }else{
                navigate('/inicio')
            }
            setIsLoading(false);
        }
        getLista_actual();
    },[fecha,idUsuario,navigate,obraId]);

    const regresar = () => {
        navigate('/inicio/Proyectos/Lista-Obras/Administracion-Obras')
    }

    const getLista_actual = async () =>{
        var date = moment( new Date());
        const fecha = date.tz('America/Mexico_City').format('YYYY-MM-DD');
        const endpoint = 'get-asis/'+obraId+'/'+fecha;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setListaAsistencia(res.data[0].asistencia);
                setInicio(res.data[0].inicio);
                setFin(res.data[0].fin);
                setSemana(res.data[0].semana);
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }

    const getFecha = () =>{
        const date= moment (new Date());
        return(date.tz('America/Mexico_City').format('YYYY-MM-DD'));
    }

    const getListaAtrasada = async () =>{
        const obId = parseInt(sessionStorage.getItem("obra"));
        const endpoint = 'personal-obra/'+obId;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setLisAtrasada(res.data)
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }

    const buscarListAsis = async (fechaSelect) =>{
        if(fechaSelect === ""){
            warningToast("SELECCIONE UNA FECHA");
        }else{
            const endpoint = 'get-asis/'+obraId+'/'+fechaSelect;
            const res = await getApi(endpoint);
            if(res.status === 1){
                if(res.data.length !== undefined){
                    setListaAsistencia(res.data[0].asistencia);
                    setInicio(res.data[0].inicio);
                    setFin(res.data[0].fin);
                    setSemana(res.data[0].semana);
                }else{
                    errorMessage(res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
        }
    }

    const asisSemana = async (idEmpleado,tipo) =>{
        const feIni = (moment(inicio,'DD/MM/YYYY').format('YYYY-MM-DD'));
        const endpoint = 'asistencia-semana/'+obraId+'/'+idEmpleado+'/'+semana+'/'+tipo+'/'+feIni;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setFechas(res.data);
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }

    const datosAsis = async (idEmpleado,fecha) =>{
        const endpoint = 'datos-asis/'+obraId+'/'+idEmpleado+'/'+fecha+'/'+tipo;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setAsisActual(res.data[0].asistencia);
                setAsistencia(res.data[0].asistencia);
                setFechaEdit(res.data[0].fecha)
                setExtra(res.data[0].extra);
                setobs(res.data[0].observacion);
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }
      
    const handleSelecTipo = async (event) =>{
        await datosAsis(idEmp,event.value)
        const grupo=document.getElementsByName(`asistencia`)
        for (let i = 0; i < grupo.length; i++) {
            const boton = grupo[i];
            boton.checked=false;
        }
    }

    const pagoExtra = () =>{
        if(extra===0){
            setExtra(1)
        }else{
            setExtra(0)
        }
    }

    //AGREGAR ASISTENCIA
    const getPersonalObra = async () =>{
        const endpoint = 'asistencia-obra/'+obraId;
        const res = await getApi(endpoint);
        if(res.status === 1){
            if(res.data.length !== undefined){
                setListEmpAsis(res.data);
            }else{
                errorMessage(res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
    }

    const addAsistencia = async (idE, nomE, appE, apmE,tip,num) =>{
        if(document.getElementById(`cb${num}`).checked){
            const asistenciaAdd = {idL: idE, nomL: nomE,
                appL: appE, apmL: apmE, obsL:'',tipo:tip,num:num
                }
                setLista([...lista, asistenciaAdd])
            var obs = document.getElementById(`ob${num}`)
            obs.disabled = false
        }else{
            var obsf = document.getElementById(`ob${num}`)
            obsf.disabled = true
            obsf.value = null
            const falta = lista.filter((item) => item.idL !== idE) ;
            setLista(falta)
        }
    }

    const handleChange = async (id) =>{
        const newUsers = lista.map((user) =>{
            if(user.num === id){
                return {...user, obsL: document.getElementById(`ob${id}`).value}
            }
            return user;
        });
        setLista(newUsers);
     }

    const guardarAsistencia = async (e) => {
        e.preventDefault()
        setSaving(true);
        const listAsistencia = JSON.stringify(lista);
        const endpoint = 'asistencia-obra/';
        const data = {lista:listAsistencia,idObra:obraId};
        const res = await postApi(endpoint,data);
        if(res.status === 1){
            if(res.data.message==="SE GUARDÓ ASISTENCIA CORRECTAMENTE"){
                handleCloseAsis();
                getLista_actual();
                successToast("AGREGADO");
            }else{
                errorToast("¡ERROR!",res.data.message);
            }
        }else if(res.status === 210){
            navigate('/');
        }else{
            errorMessage(res.message);
        }
        setSaving(false);
    }
        
    //EDITAR ASISTENCIA
    const update= async (e) => {
        e.preventDefault()
        setSaving(true);
        if(fechaEdit ===undefined || fechaEdit ===''){
            warningToast('DEBE INGRESAR UNA FECHA','',false);
        }else{
            const asist = parseFloat(asistencia)
            const endpoint = 'asistencia-obra/'+obraId+'/emp/'+idEmp;
            const data = {fecha:fechaEdit,asistencia:asist,extra:extra,tipo:tipo};
            const res = await putApi(endpoint,data);
            if(res.status === 1){
                if(res.data.message==="¡Registro modificado correctamente!"){
                    handleCloseEdit();
                    buscarListAsis(fechaEdit);
                    successToast("EDITADO");
                }else{
                    errorToast("¡ERROR!",res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
        }
        setSaving(false);
    }
   
    const handlePer =(val1)=>{
        const data = JSON.parse(val1)
        setNombre(data.id)
        setTipo(data.ti)
    }

    const store = async (e) =>{
        e.preventDefault()
        //console.log(nombre,tipo)
        const idEmp = parseInt(nombre)
        const asis = parseFloat(asisAtras)
        if(nombre === null || fechaAtrasada === null || asisAtras === null){
            warningToast('CAMPOS VACIOS','rellene los campos obligatorios',false);
        }else{
            setSaving(true);
            const endpoint = 'asistencia-atrasada-obra/';
            const data = {idObra:obraId,idEmpleado:idEmp, asistencia:asis, fecha:fechaAtrasada, observacion:observacion,tipo:tipo};
            const res = await postApi(endpoint,data);
            if(res.status === 1){
                if(res.data.message==="SE GUARDÓ ASISTENCIA CORRECTAMENTE"){
                    handleCloseAdd();
                    buscarListAsis(fechaAtrasada);
                    successToast("AGREGADO");
                }else{
                    errorToast("¡ERROR!",res.data.message);
                }
            }else if(res.status === 210){
                navigate('/');
            }else{
                errorMessage(res.message);
            }
            setSaving(false);
        }
    }
  
    return(
        <div className="tablaHerramientas">
            {
                isLoading === true ? 
                <Loading />:
                <div>
                    <div className='contabilidades-header'>
                        <div className='fab'><FaArrowLeftLong className='arrow' onClick={regresar} title='REGRESAR'/></div>
                        <label className="text-uppercase">ASISTENCIA DE LA OBRA</label>
                    </div>
                    <div>
                        <h4 className='text-uppercase'>{obra}</h4>
                    </div>
                    <div className='divbotonE'  >                                                                                             
                        <div className='botonE' style={{display:'flex', justifyContent:'space-between'}} >
                            {day === 7 ?(
                                <button  className="btn btncolor" disabled>
                                    <label className="agregar">ASISTENCIA &nbsp;</label><FaUserCheck title="ASISTENCIA" style={{fontSize:'20px'}}/>
                                </button>
                            ):(
                                <button  className="btn btncolor" onClick={()=> handleShowAsis()}>
                                    <label className="agregar">ASISTENCIA &nbsp;</label><FaUserCheck title="ASISTENCIA" style={{fontSize:'20px'}}/>
                                </button>
                            )}
                            <div className="fecha" style={{display:'flex', justifyContent:'space-between'}}>
                                <input type="date" className="form-control"   max={getFecha()} onChange={(e)=>setFechaSelect(e.target.value)} aria-describedby="basic-addon1"/>
                                <button type="button" className="btn btncolor" onClick={()=> buscarListAsis(fechaSelect)}  >BUSCAR</button>
                            </div>
                            {/*<input className="form-control" value={busqueda} onChange={buscar} style={{width:'50%'}} type="search" placeholder="Buscar" aria-label="Search"/>*/}
                        </div>
                    </div>
                    <div className='divbotonE'>
                        {day !== 7  ?(
                            <div className='divbotonE'  style={{display:'flex', justifyContent:'space-between'}}>
                                <button  className="btn btncolor" onClick={() => handleShowAdd()}>
                                    <label className="agregar">ASISTENCIA ATRASADA &nbsp;</label><FaUserCheck title="ASISTENCIA" style={{fontSize:'20px'}}/>
                                </button>                                 
                            </div>
                            /*data-bs-toggle="modal" data-bs-target="#modal-agregar-asistencia"*/ 
                        ):(
                            <div className='botonE'>
                                <button  className="btn btncolor" disabled>
                                    <label className="agregar">ASISTENCIA ATRASADA &nbsp;</label><FaUserCheck title="ASISTENCIA" style={{fontSize:'20px'}}/>
                                </button>
                            </div>
                        )}
                            <div>
                                <p style={{fontWeight:"bold"}}>{"SEMANA: "+ inicio+" - "+ fin} </p>
                            </div>
                    </div>
                        {/*<div className='divbotonE'  style={{display:'flex', justifyContent:'space-between'}}>
                        </div>*/}
                    { listaAsistencia.length === 0 ? (<h3 style={{marginTop:'30vh'}}>NO HAY REGISTROS</h3>):(
                        <div className="caja-asistencia" >
                            <div className="table tabla">
                                <table className="table table-hover table-bordered text-uppercase">
                                    <thead className="encabezado">
                                        <tr >
                                            <th>EMPLEADO</th>
                                            <th>L</th>
                                            <th>M</th>
                                            <th>M</th>
                                            <th>J</th>
                                            <th>V</th>
                                            <th>S</th>
                                            <th>EDITAR</th>
                                        </tr>
                                    </thead>
                                    <tbody >
                                        {listaAsistencia.map(p =>{
                                            return(
                                                <tr key={p.num}>
                                                    <td>{p.nombreEmp}</td>
                                                    <td>
                                                        {p.lunes=== 1 ? (<FcCheckmark size={25} title={p.obsLunes}/>):(
                                                        p.lunes === 0.5 ? (<MdTimerOff size={25} color="#1A2E4F" title={p.obsLunes}/>)
                                                        :(p.lunes === 0 ? (<IoClose size={30} color="red" title={p.obsLunes}/> ) :(null)))}
                                                    </td>
                                                    <td>
                                                        {p.martes === 1 ? (<FcCheckmark size={25} title={p.obsMartes} />):(
                                                        p.martes === 0.5 ? (<MdTimerOff size={25} color="#1A2E4F" title={p.obsMartes} />):
                                                        (p.martes === 0 ? (<IoClose size={30} color="red" title={p.obsMartes}/>) :(null)))}
                                                    </td>
                                                    <td>
                                                        {p.miercoles === 1 ? (<FcCheckmark size={25} title={p.obsMiercoles} />):(
                                                        p.miercoles === 0.5 ? (<MdTimerOff size={25} color="#1A2E4F" title={p.obsMiercoles} />)
                                                        :(p.miercoles === 0 ? (<IoClose size={30} color="red" title={p.obsMiercoles}/> ) :(null)))}
                                                    </td>
                                                    <td>
                                                        {p.jueves === 1 ? (<FcCheckmark size={25} title={p.obsJueves}/>):(
                                                        p.jueves === 0.5 ? (<MdTimerOff size={25} color="#1A2E4F" title={p.obsJueves}/>)
                                                        :(p.jueves === 0 ? (<IoClose size={30} color="red" title={p.obsJueves}/> ) :(null)))}
                                                    </td>
                                                    <td>
                                                        {p.viernes === 1 ? (<FcCheckmark size={25} title={p.obsViernes}/>):(
                                                        p.viernes === 0.5 ? (<MdTimerOff size={25} color="#1A2E4F" title={p.obsViernes}/>)
                                                        :(p.viernes === 0 ? (<IoClose size={30} color="red" title={p.obsViernes}/> ) :(null)))}
                                                    </td>
                                                    <td>
                                                        {p.sabado === 1 ? (<FcCheckmark size={25} title={p.obsSabado}/>):(
                                                        p.sabado === 0.5 ? (<MdTimerOff size={25} color="#1A2E4F" title={p.obsSabado}/>)
                                                        : (p.sabado === 0 ? (<IoClose size={30} color="red" title={p.obsSabado}/> ) :(null)))}
                                                    </td>
                                                    {/*<td>{p.observacion}</td>
                                                    <td>{moment(p.fecha).format("DD-MM-YYYY")}</td>*/}
                                                    <td>
                                                        <FaEdit size={20} cursor="pointer" title="EDITAR" 
                                                        onClick={() => handleShowEdit(p.idEmpleado,p.nombreEmp,p.tipo)} />           
                                                    </td>
                                                </tr>
                                            )
                                        })}                        
                                    </tbody>
                                </table>
                            </div>           
                        </div>
                    )}

                    {/*AGREGAR ASISTENCIA */}
                    <Modal  size="lg" show={showListAsis} onHide={handleCloseAsis} id="modal-agregar-asis" >
                        <Modal.Header className=' btncolor'>
                            <Modal.Title> ASISTENCIA</Modal.Title>
                            <CloseButton  style={{backgroundColor:"white"}}  onClick={handleCloseAsis}/>
                        </Modal.Header>
                        <form onSubmit={guardarAsistencia}>
                            <Modal.Body >
                                { listEmpAsis.length === 0 ? (<h3 style={{marginTop:'10vh',textAlign:"center"}}>NO HAY REGISTROS</h3>):(
                                    <div className="tabla-cajaA" style={{ height:'55vh', overflowY:"scroll" }} >
                                        <div className="table tabla">
                                            <table className="table  text-uppercase">
                                                <thead >
                                                    <tr >
                                                        <th>EMPLEADO</th>
                                                        <th>ASISTENCIA</th>
                                                        <th>OBSERVACIONES</th>
                                                    </tr>
                                                </thead>
                                                <tbody >
                                                    {listEmpAsis.map(p =>{
                                                        return(
                                                            <tr key={p.num}>
                                                                <td>{p.nombreEmp}{' '}{p.apellidoPaternoEmp}{' '}{p.apellidoMaternoEmp}</td>
                                                                <td>
                                                                    <input className="form-check-input" type="checkbox" id={`cb${p.num}`} 
                                                                        onClick={()=>addAsistencia(p.idEmpleado, 
                                                                        p.nombreEmp, p.apellidoPaternoEmp, 
                                                                        p.apellidoMaternoEmp,p.tipo,p.num)}
                                                                    />
                                                                </td>
                                                                <td>
                                                                    <input type="text" id={`ob${p.num}`} onChange={()=>handleChange(p.num)} disabled/>
                                                                </td>
                                                            </tr>                             
                                                        )
                                                    })}                        
                                                </tbody>
                                            </table>
                                        </div>           
                                    </div>
                                )}
                            </Modal.Body>
                            <Modal.Footer>
                                <button type="button" className="btn btn-secondary"  onClick={handleCloseAsis}>CANCELAR</button>
                                {lista.length === 0 ? (
                                    <button type="button" className="btn btncolor" disabled >GUARDAR ASISTENCIA</button>
                                ):(
                                    isSaving===true?
                                    <button type="submit" className="btn btncolor" >GUARDAR ASISTENCIA
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Loading...
                                    </button>:
                                    <button type="submit" className="btn btncolor" >GUARDAR ASISTENCIA</button>
                                )}                                               
                            </Modal.Footer>
                        </form>
                    </Modal>

                    {/*EDITAR ASISTENCIA*/}
                    <Modal  show={showEdit} onHide={handleCloseEdit} id="modal-editar-asis">
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>EDITAR ASISTENCIA</Modal.Title>
                            <CloseButton  style={{backgroundColor:"white"}}  onClick={handleCloseEdit}/>
                        </Modal.Header>
                        <form onSubmit={update}>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                            <Modal.Body  style={{textAlign:'left', marginTop:'-20px'}}>
                                <div className="mb-3" style={{textAlign:'center'}}>
                                    <h5 className="modal-title text-uppercase" id="exampleModalLabel">OBRA: {obra}</h5>
                                </div>
                                <div className="row">
                                    <div className="col" style={{textAlign:'right'}}>
                                        <label htmlFor="exampleFormControlInput1" className="form-label">NOMBRE DEL PERSONAL:</label>
                                    </div>
                                    <div className="col">
                                        <label htmlFor="exampleFormControlInput1" className="form-label"><strong>{editNombre}</strong></label>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col" style={{textAlign:'right'}}>
                                        <label htmlFor="exampleFormControlInput1" className="form-label">SELECCIONAR</label>
                                    </div>
                                    <div className="col">
                                        <Select
                                                classNamePrefix="select"
                                                required
                                                options={fechas.map(f=>({label:moment(f.fecha).format("DD-MM-YYYY"),value:f.fecha}))}
                                                onChange={handleSelecTipo}
                                            />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col" style={{textAlign:'right'}}>
                                        <label htmlFor="exampleFormControlInput1" className="form-label">ASISTENCIA:</label>
                                    </div>
                                    <div className="col">
                                        <label className="form-label">
                                            {<strong >
                                                {asisActual === 1 ? (<FcCheckmark size={25} />):(
                                                    asisActual === 0.5 ? (<MdTimerOff size={25} color="#1A2E4F" title="MEDIO DIA"/>):(
                                                    asisActual===0?(<IoClose size={30} color="red"/>):(null)))}
                                                </strong>}
                                        </label>
                                    </div>
                                </div>
                                    <div className="row">
                                        <div className="col" style={{textAlign:'right'}}>
                                            <label className="form-label">OBSERVACION:</label>
                                        </div>
                                        <div className="col">
                                            <label className="form-label"><strong>{obs}</strong></label>
                                        </div>
                                    </div>
                                <hr />
                                <div className="mb-3" style={{textAlign:'center'}}>
                                    <h5 className="modal-title text-uppercase">CAMBIAR ASISTENCIA<label title="OBLIGATORIO" className="obligatorio">*</label></h5>
                                </div>
                                <div className="mb-3" style={{textAlign:'center'}}>
                                    <div onChange={e => setAsistencia(e.target.value)}>
                                        {asisActual === 1 ? (
                                            <div className="form-check form-check-inline"  >
                                                    <input className="form-check-input" type="radio" value="1" disabled name="asistencia" id="asistencia1"/>
                                                    <label className="form-check-label" htmlFor="asistencia1">
                                                        ASISTIÓ
                                                    </label>
                                            </div>
                                        )
                                        :
                                        ( <div className="form-check form-check-inline"  >
                                        <input className="form-check-input" type="radio" value="1" name="asistencia" id="asistencia1" />
                                        <label className="form-check-label" htmlFor="asistencia1">
                                            ASISTIÓ
                                        </label>
                                        </div>)}
                                        
                                        {asisActual === 0 ? (
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" value="0" disabled name="asistencia" id="asistencia2" />
                                                <label className="form-check-label" htmlFor="asistencia2">
                                                    NO ASISTIÓ
                                                </label>
                                            </div>
                                        )
                                        :
                                            (<div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" value="0" name="asistencia" id="asistencia2" />
                                            <label className="form-check-label" htmlFor="asistencia2">
                                                NO ASISTIÓ
                                            </label>
                                            </div>)}
                                    
                                        {asisActual === 0.5 ? (
                                            <div className="form-check form-check-inline">
                                                <input className="form-check-input" type="radio" disabled value="0.5" name="asistencia" id="asistencia3" />
                                                <label className="form-check-label" htmlFor="asistencia3">
                                                    MEDIO DIA
                                                </label>
                                            </div>
                                        )
                                        :
                                        (<div className="form-check form-check-inline">
                                        <input className="form-check-input" type="radio" value="0.5" name="asistencia" id="asistencia3" />
                                        <label className="form-check-label" htmlFor="asistencia3">
                                            MEDIO DIA
                                        </label>
                                        </div>)}                               
                                    </div>
                                </div>
                                <hr />
                                <div className="mb-3" style={{textAlign:'center'}}>
                                    <div className="form-check form-check-inline">
                                        <input className="form-check-input" type="checkbox" onChange={()=>pagoExtra()} 
                                        checked={extra===1?true:false}/>
                                        <label className="form-check-label" htmlFor="flexCheckDefault">
                                            PAGO EXTRA
                                        </label>
                                    </div>
                                </div>
                            </Modal.Body>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={handleCloseEdit}>CANCELAR</button>
                                {
                                    isSaving===true?
                                    <button type="submit" className="btn btncolor" >GUARDAR CAMBIOS
                                        <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        Loading...
                                    </button>:
                                    <button  className="btn btncolor" type="submit"  >GUARDAR CAMBIOS</button> 
                                }
                                                           
                            </div>
                        </form>
                    </Modal>
                
                    {/*AGREGAR ASISTENCIA ATRASADA*/}
                    <Modal  show={showAddAsis} onHide={handleCloseAdd} id="modal-asisAtr">
                        <Modal.Header className=' btncolor'>
                            <Modal.Title>AGREGAR ASISTENCIA</Modal.Title>
                            <CloseButton  style={{backgroundColor:"white"}}  onClick={handleCloseAdd}/>
                        </Modal.Header>
                        <form onSubmit={store}>
                            <div className="divO">
                                <label className="obligatorio">Obligatorio *</label>  
                            </div>
                            <Modal.Body  style={{textAlign:'left', marginTop:'-20px'}}>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">NOMBRE <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <select className="form-control" required 
                                        onChange={e => handlePer(e.target.value) }   >
                                        <option >--Seleccione una opción--</option>
                                        {listAtrasada.map(p => {
                                            return(
                                                <option key={p.num} value={JSON.stringify({id:p.idEmpleado,ti:p.tipo})} >{p.nombreEmp+" "+p.apellidoPaternoEmp}</option>
                                            )
                                        })
                                        }                                
                                    </select>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">FECHA <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <input type="date" className="form-control"  id="exampleFormControlInput1" required 
                                    onChange={e => setFechaAtrasada(e.target.value) }/>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">ASISTENCIA <label title="OBLIGATORIO" className="obligatorio">*</label></label>
                                    <div onChange={e => setAsisAtras(e.target.value)}>
                                        <div className="form-check form-check-inline" >
                                            <input className="form-check-input" type="radio" value="1" name="asistencia" id="asistencia1"  required/>
                                            <label className="form-check-label" htmlFor="asistencia1">
                                                ASISTIÓ
                                            </label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" value="0" name="asistencia" id="asistencia2" />
                                            <label className="form-check-label" htmlFor="asistencia2">
                                                NO ASISTIÓ
                                            </label>
                                        </div>
                                        <div className="form-check form-check-inline">
                                            <input className="form-check-input" type="radio" value="0.5" name="asistencia" id="asistencia3" />
                                            <label className="form-check-label" htmlFor="asistencia3">
                                                MEDIO DIA
                                            </label>
                                        </div>                               
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <label htmlFor="exampleFormControlInput1" className="form-label">OBSERVACION </label>
                                    <input type="text" className="form-control"  id="exampleFormControlInput1"
                                    onChange={e => setObservacion(e.target.value) }/>
                                </div> 
                            </Modal.Body>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={handleCloseAdd}>CANCELAR</button>                                               
                                <button  className="btn btncolor" type="submit"  >GUARDAR CAMBIOS</button>                                                
                            </div>
                        </form>
                    </Modal>
                </div>
            }
        </div>
    )
}

export default AsistenciaObra;